export const JOB_APPLY_COOKIE_NAME = 'job_apply';

// sessionStorage flag set when a guest is sent to login from the apply button. The
// after-apply page reads it (and clears it) to know the only history entry to go
// "back" to is the now-useless /login page, so its back button goes home instead.
export const JOB_APPLY_FROM_LOGIN_KEY = 'job_apply_from_login';

export const JOB_APPLY_WEB_TYPE = 0;

export const JOB_DETAIL_SIMILAR_JOBS_LIMIT = 4;

export const BULK_APPLY_JOB_LIST_LIMIT = 6;

export const JOB_LIST_ITEMS_PER_PAGE = 24;

export const STORIES_TO_SHOW = 24;

export const FLOW_JOB_LIST_PASSIVE_RECOMMENDATION_COLUMN_ID = 1;

export const SIMILAR_JOB_LIST_ITEMS_PER_PAGE = 50;

export const COOKIE_ANON_SESSION_ID = '_asid';

export const MY_JOBS_SORTING_OPTIONS = ['new', 'recent', 'lastActivity', 'lad'] as const;

export const MY_JOBS_STATUS_FILTER_OPTIONS = [
  'all',
  'active',
  'inactive',
  // 'draft', Temporarily hidden
] as const;

export const MAX_ENABLED_INTERVIEW_QUESTIONS = 6;
